// ProtectedRoute.jsx (DROP-IN)
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

const MFA_PENDING_KEY = "nx_mfa_pending";

function isClientMfaPending() {
  try {
    return sessionStorage.getItem(MFA_PENDING_KEY) === "1";
  } catch {
    return false;
  }
}

export default function ProtectedRoute({ redirectTo = "/login" }) {
  const { currentUser, loading } = useAuth();
  const location = useLocation();

  if (loading) return null;

  const mfaPending = isClientMfaPending();

  // ✅ Treat MFA pending as NOT authenticated (prevents social bypass into protected pages)
  const isAuthed = !mfaPending && !!currentUser && (currentUser.uid || currentUser._source === "cookie");

  console.log("ProtectedRoute:", { allow: isAuthed, mfaPending });

  if (!isAuthed) {
    // ✅ preserve full deep link (path + query)
    const from = location.pathname + location.search;

    // ✅ persist across tabs / refresh (state can be lost; localStorage won't)
    try {
      localStorage.setItem("postLoginRedirect", from);
    } catch {
      // ignore storage failures
    }

    return <Navigate to={redirectTo} replace state={{ from }} />;
  }

  return <Outlet />;
}
